import { render, staticRenderFns } from "./BusChangeSetupDialog.vue?vue&type=template&id=b92a4930&scoped=true&"
import script from "./BusChangeSetupDialog.vue?vue&type=script&lang=js&"
export * from "./BusChangeSetupDialog.vue?vue&type=script&lang=js&"
import style0 from "./BusChangeSetupDialog.vue?vue&type=style&index=0&id=b92a4930&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b92a4930",
  null
  
)

export default component.exports